import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { MbIcon } from '@am/moebius';

@Component({
    selector: 'button-disney',
    templateUrl: './button-disney.component.html',
    styleUrls: ['./button-disney.component.scss'],
    standalone: true,
    imports: [MbIcon],
})
export class ButtonDisneyComponent implements OnInit {
  @Output() btnClick: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor() {}

  ngOnInit() {}

  btnClickOutput() {
    this.btnClick.emit(true);
  }
}
